<script setup>
import { ref, nextTick, defineExpose } from 'vue'
import Popover from 'primevue/popover'

/* ---------- Local state ---------- */
const op = ref()
const selectedRow = ref()

/* ---------- Methods ---------- */
const displayHotOrders = (event, row) => {
  op.value.hide()
  selectedRow.value = row
  nextTick(() => {
    if (row.hotOrders?.length) op.value.show(event)
  })
}

const hidePopover = () => {
  op.value.hide()
}

/* ---------- Expose methods to parent ---------- */
defineExpose({
  displayHotOrders,
  hidePopover,
})
</script>

<template>
  <Popover
      ref="op"
      class="!bg-slate-700 !text-white !text-xs !border-slate-600 before:!hidden after:!hidden !mt-0 custom-popover"
      content-class="!p-0"
  >
    <div v-if="selectedRow" class="rounded flex flex-col divide-y divide-gray-600">
      <table class="min-w-full border border-gray-600 rounded-lg overflow-hidden">
        <tbody>
        <tr
            v-for="hotOrder in selectedRow.hotOrders"
            :key="hotOrder.id"
            class="odd:bg-slate-800 even:bg-slate-700"
        >
          <td class="px-2 py-2 border-t border-gray-600">{{ hotOrder.takerName || 'Unassigned' }}</td>
          <td class="px-2 py-2 border-t border-gray-600">{{ hotOrder.currency }}</td>
          <td class="px-2 py-2 border-t border-gray-600">{{ hotOrder.value || hotOrder.price }} $</td>
          <td class="px-2 py-2 border-t border-gray-600">{{ hotOrder.state }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </Popover>
</template>
